import { useTranslation } from "@/hooks/useTranslation"
import { LinkButton } from "@/molecules/LinkButton"
import { LinkOverview } from "./LinkOverview"

import styles from "./IntegrationStatusButtonsContainer.module.scss"

import type { ButtonsContainerProps } from "."

export const IntegrationStatusButtonsContainer = (
  props: ButtonsContainerProps
) => {
  const { status, vendor, vendorName, configurationExist } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.callback"
  })

  return (
    <div className={styles.buttonsContainer}>
      {status === "SUCCESS" && (
        <>
          {configurationExist && (
            <LinkButton
              to={`/integrations/${vendor}?tab=configuration`}
              type="primary"
            >
              {t("configureIntegration")}
            </LinkButton>
          )}
          {!configurationExist && <LinkOverview t={t} />}
        </>
      )}
      {status === "ERROR" && (
        <LinkButton to={`/integrations/${vendor}?tab=connect`}>
          <span className={styles.buttonText}>
            {t("backToVendorIntegration", { name: vendorName })}
          </span>
        </LinkButton>
      )}
      {status === "REQUESTED" && (
        <>
          <LinkOverview t={t} />
          <LinkButton to="/integrations" type="primary">
            <span className={styles.buttonText}>{t("linkToIntegrations")}</span>
          </LinkButton>
        </>
      )}
    </div>
  )
}
